import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import './landing.css';

const landingBackground = {
  backgroundImage: `url(${process.env.PUBLIC_URL + '/img/landing_background.jpg'})`,
};

export default class LandingPage extends React.PureComponent<RouteComponentProps<{}>, {}> {
  render(): JSX.Element {
    return (
      <div className="landing background" style={landingBackground}>
        <section className="hero is-fullheight">
          <div className="hero-body">
            <div className="container">
              <div className="columns is-centered">
                <div className="column is-narrow">
                  <div className="card-content is-glowing">
                    <h1 className="title is-cursive is-shadowed is-1">Briana &amp; Matt's Wedding</h1>
                    <h2 className="subtitle">
                      North Shore, Oahu, Hawaii
                      <br />
                      May 19, 2018
                    </h2>

                    <Link to="/rsvp" className="button is-dark is-cursive is-size-4 is-fullwidth">
                      RSVP
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/landing.tsx